import styled from 'styled-components';
import { rem } from 'polished';
import Select from 'react-dropdown-select';

import { device } from '../../globalStyle';

export const Label = styled.label`
  display: block;
  font-weight: 500;
  padding: var(--space-md) 0;
  white-space: pre-line;
`;

export const AdditionalLabel = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  padding: 0 0 var(--space-md);
  white-space: pre-line;
`;

export const Button = styled.button`
  color: white;
  cursor: pointer;
  font-weight: 500;
  padding: 15px 30px;
  text-align: center;
  letter-spacing: 1px;
  border-radius: 105px;
  text-decoration: none;
  text-transform: uppercase;
  font-family: 'Gotham-Bold';
  background: var(--c-light-blue);
  border: 1px solid var(--c-light-blue);
  transition: background-color 0.3s ease-in-out;

  @media only screen and (${device.sm}) {
    height: 50px;
  }

  &:hover {
    background: var(--c-blue);
  }
`;

export const ButtonWrapper = styled.div`
  flex: 1 1 100%;
  margin-bottom: 30px;
`;

export const Caption = styled.div`
  font-size: ${rem('14px')};
  margin: var(--space-sm) 0;
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : 0)};
`;

export const SuccessBlip = styled.span`
  background-color: var(--c-green);
  border-radius: 999px;
  display: inline-block;
  width: 0.75em;
  height: 0.75em;
  color: white;
  vertical-align: middle;
  text-align: center;
  margin-left: 5px;
  margin-right: 5px;
  body[dir='ltr'] & {
    margin-left: 0;
  }
  body[dir='rtl'] & {
    margin-right: 0;
  }
`;

export const Error = styled.div`
  color: var(--c-red);
  margin-bottom: var(--space-md);
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  min-height: 30px;
  font-size: ${rem('16px')};
  cursor: pointer;
  flex: 1 1 50%;

  & input {
    margin: 0;
    position: absolute;
    min-width: 20px;
    min-height: 20px;
  }

  & .checkbox-style {
    display: block;
    background: #323232;
    min-width: 20px;
    min-height: 20px;
    border-radius: 2px;
    transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out;
    position: relative;
    z-index: 1;
    margin-right: var(--space-md);
  }

  body[dir='ltr'] & .checkbox-style {
    margin-left: 0;
  }
  body[dir='rtl'] & .checkbox-style {
    margin-right: 0;
  }

  & .checkbox-style:after {
    width: 20px;
    height: 20px;
    line-height: 20px;
    content: '\\2013';
    text-align: center;
    display: block;
    font-weight: bold;
    position: absolute;
    top: 0;
    left: 0;
    color: white;
  }

  & .checkbox-style.checkbox-style--checked {
    background: var(--c-blue);
  }

  & .checkbox-style.checkbox-style--disabled {
    background: #323232;
    cursor: not-allowed;
  }

  & .checkbox-style.checkbox-style--checked:after {
    content: '\\2713';
  }

  & .checkbox-label.checkbox-label--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const DropdownSelect = styled(Select)``;

export const OtherTextInput = styled.div`
  margin-top: var(--space-md);
`;

export const FilesUploader = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FileUploaderContainer = styled.div`
  cursor: pointer;
  border-width: 2px;
  border-radius: 5px;
  text-align: center;
  border-style: dashed;
  color: ${({ theme }) => theme.text};
  border-color: ${({ theme }) => theme.borderColor};
  background-color: ${({ theme }) => theme.background};
`;

export const UploadedFile = styled.div`
  margin: 5px 0;
`;

export const Blip = styled.span`
  margin: 0 5px;
  width: 0.7em;
  height: 0.7em;
  border-radius: 10px;
  display: inline-block;
  background-color: #66883e;
  body[dir='ltr'] & {
    margin-left: 0;
  }
  body[dir='rtl'] & {
    margin-right: 0;
  }
`;

export const ProgressBarWrapper = styled.div`
  max-width: 350px;
  margin-top: 5px;
  position: relative;
`;

export const ProgressBarFill = styled.div`
  height: 12px;
  border-radius: 3px;
  background-color: green;
  width: ${(props) => props.progress}%;
`;

export const ProgressBarText = styled.div`
  left: 0;
  right: 0;
  font-size: 10px;
  margin-left: auto;
  position: absolute;
  margin-right: auto;
  text-align: center;
`;
